import React from 'react'
import { useState } from 'react';
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import moment from "moment-timezone";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

const Transactions = ({transArr,page, rowsPerPage, onChangePage, onChangeRowsPerPage,totalCount}) => {


    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(5);

    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    //   };
    
    //   const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    //   };

      const rows = [
        { name: 'Item 1', value: 100 },
        { name: 'Item 2', value: 200 },
        { name: 'Item 3', value: 300 },
        { name: 'Item 4', value: 400 },
        { name: 'Item 5', value: 500 },
        { name: 'Item 6', value: 600 },
      ];

    


    return (
        <div className="custom-table-data">
            <h4 className="dark-gray f-bold mb-4">Transactions</h4>
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell align="center">
                                Transaction No.
                            </TableCell>
                            <TableCell align="center">Bet site</TableCell>
                            <TableCell align="center">Match</TableCell>
                            <TableCell align="center">Description </TableCell>
                            <TableCell align="center">Transaction </TableCell>
                            <TableCell align="center">Method </TableCell>
                            <TableCell align="center">Amount </TableCell>
                            <TableCell align="center">Status </TableCell>
                            <TableCell align="center">Actions </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {transArr.map((row) => (
                            <TableRow
                                key={row.insertion_time}
                                sx={{
                                    "&:last-child td, &:last-child th": {
                                        border: 0,
                                    },
                                }}
                            >
                                <TableCell component="th" scope="row">
                                    {moment(row.insertion_time).format(
                                        "MM/DD/YYYY"
                                    )}
                                </TableCell>
                                <TableCell align="center">
                                    {row.id_transaction}
                                </TableCell>
                                                                <TableCell align="center">
                                    {row?.bet_type == 1? "P2P":(row?.bet_type == 2? "Multi Line":"")}
                                </TableCell>
                               <TableCell align="center">
                                    {row?.bet_name}
                                </TableCell>
                                <TableCell align="center">
                                    {row.description}
                                </TableCell>
                                <TableCell align="center">
                                    {row.wallet_operation}
                                </TableCell>
                                <TableCell align="center">
                                    {row.wallet_type}
                                </TableCell>
                                <TableCell align="center">
                                    {row.tamount}
                                </TableCell>
                                <TableCell align="center">
                                    {row.transaction_status}
                                </TableCell>
                                {/* <TableCell align="right">{row.carbs}</TableCell> */}
                                <TableCell align="center">
                                    {row.protein}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    <TableFooter>
                    <TableRow>
                    <TableCell colSpan={12} sx={{ textAlign: 'left' }}>   
                    <TablePagination
                                  rowsPerPageOptions={[5, 10,25]}
                                  count={totalCount}
                                  rowsPerPage={rowsPerPage}
                                  page={page}
                                  onPageChange={onChangePage}
                                  onRowsPerPageChange={onChangeRowsPerPage}
                    />
                    </TableCell>
                    </TableRow>    
                    </TableFooter>
                </Table>
            </TableContainer>
        </div>
    )
}

export default Transactions